import React from 'react'
import MaterialTable from 'material-table';
import { darken, Grid, Paper } from '@material-ui/core';
import { useSelector } from 'react-redux';
import { useStyles } from '../reportStyles';

import { COLORS_PROJECT } from '../../../constants';


const {color_nav,color_nav_letter}= COLORS_PROJECT;


export const ReportModelAlertsTable = () => {
    const classes = useStyles();
    const {data,namePoint} = useSelector(state => state.print)
    const {10:dataTable=[]}= data
    const {listaAlertas}=dataTable

    let name;
    if(namePoint){
        name= namePoint
    }else{
        name=''
    }

    const {colorPoints,nameAlerts} = useSelector(state => state.auth) // nameColors
    const arrColors = colorPoints.split(",")
    //const arrNames = nameColors.split(",")
    const arrNamesAlerts = nameAlerts.split(",")
    

    return (
        <Grid item container spacing={3} xs={12} md={12} lg={12}>
            <Grid item xs={12} md={12} lg={12}>
                <Paper className={classes.paper}>
                    <MaterialTable
                        title = {`Reporte Alertas TWS ${name}`}
                        columns={[
                            {
                                field: 'nombre',
                                title: 'TWS',
                            },
                            {
                                field: 'fecha_on',
                                title: 'Fecha',
                                render: rowData => (
                                    rowData.fecha_on.substr(0, 10)
                                ),
                                export: false,
                            },
                            {
                                field: 'fecha_on',
                                title: 'Inicio',
                                render: rowData => (
                                    rowData.fecha_on.substr(10, 6)
                                ),
                            },
                            {
                                field: 'fecha_off',
                                title: 'Fin',
                                render: rowData => (
                                    rowData.fecha_off.substr(10, 6)
                                ),
                            },
                            {
                                field: 'nivel',
                                title: 'Nivel de Alerta',
                                render: rowData => {
                                    switch (rowData.nivel) {
                                        case 1:
                                            return arrNamesAlerts[0]
                                        case 2:
                                            return arrNamesAlerts[1]
                                        case 3:
                                            return arrNamesAlerts[2]
                                        default:
                                            return 'NINGUNA';
                                    }
                                },
                                cellStyle: (e,rowData) => {
                                    switch (rowData.nivel) {
                                        case 3:
                                            return { backgroundColor: arrColors[3] };
                                        case 2:
                                            return { backgroundColor: arrColors[2]  };
                                        case 1:
                                            return { backgroundColor: arrColors[1]};
                                        default:
                                            return {backgroundColor: 'white'  };
                                    }
                                },
                            },
                            {
                                field: 'duracion',
                                title: 'Duración [hh:mm]',
                                render: rowData => (
                                    rowData.duracion.substr(0, 5)
                                ),
                            },
                        ]}

                        data={listaAlertas}

                        options={{
                            paging: false,
                            search: false,
                            exportButton: true,
                       
                            headerStyle: {
                                backgroundColor: darken(color_nav, 0.2),
                                color: color_nav_letter
                            },
                            
                            
                        }}

                        localization={{
                            toolbar: {
                              exportCSVName: "Exportar como CSV",
                              exportPDFName: ""
                            },
                            body:{
                                emptyDataSourceMessage: 'No hay reporte',
                            },

                        }}
                    />
                </Paper>
            </Grid>
        </Grid>
        
    )
}
